export default "__VITE_ASSET__BmuV89aa__"